<template>
  <div>
    <v-dialog
        v-model="addUserDialog"
        max-width="1000px"
        content-class="showOverflow"
    >
      <v-container fluid class="pa-0 ma-0">
        <user-create
            dialog
            simple
            :user="user"
            :householdId="this.householdId"
            @on-user-added="userAdded"
            @new-spouse_id="newSpouseId"
            @on-close="addUserDialog = false"
            :agent-id="agentId"
        />
      </v-container>
    </v-dialog>


        <div class="text-center" >
          <v-btn small block text color="primary" class="mt-1" @click="addUserDialog = true">Add New</v-btn>
        </div>
  </div>
</template>
<script>
import UserCreate from '@/views/users/CreateByClient'
export default {
  name: 'UserSearchFieldClientEdit',
  components: {
    UserCreate
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'user'
    },
    householdId:[String, Number],
    clearable: Boolean,
    disableNew: Boolean,
    agentId: [String, Number]
  },
  data () {
    return {
      searching: false,
      users: [],
      search: null,
      searchTimeout: null,

      addUserDialog: false
    }
  },
  mounted () {
    this.newSpouseId()
    // console.log(this.user)
    this.getDataFromApi()
  },
  watch: {
    search () {
      let ref = this
      if(this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(function() {
        ref.getDataFromApi()
      }, 300)
    }
  },
  methods: {
    getDataFromApi() {
      let queryParams = [];

      queryParams = {'agent_id': this.user.agent_id, user_id:this.user.id }

      if(this.search) queryParams = {'agent_id': this.user.agent_id, user_id:this.user.id, search:this.search }

      this.$http.post('household-customer-data/get-users-by-agent', queryParams)
          .then(response => {
            this.users = response.data
          })
          .catch(err => {
            console.log(err.response)
            this.$swal.fire('Error', 'Error loading users', 'error')
          })

    },
    userAdded (data) {
      this.$emit('update:user', data.user)
      this.$emit('on-user-added', data)
    },
    newSpouseId(data){
      if(data && data.spouse.id){
        this.$emit('new-spouse_id',  {spouse: data.spouse})
      }
    },
    update (e) {
      let user_id = e.id;
      let queryParams = {householdId: this.householdId, user_id: user_id}
      this.$http.post('household-customer-data/update-spouse-id', queryParams)
          .then(() => {
            // console.log(response.data)
            // this.users = response.data
          })
          .catch(err => {
            console.log(err.response)
            this.$swal.fire('Error', 'Error loading users', 'error')
          })
    }

  }
}
</script>